import { LegalLayout } from "@/layouts/LegalLayout.tsx";

export function TOSPage() {
    return <LegalLayout url="/terms-of-service.html" />;
}
